import React from "react";
import { useTranslation } from "@/context/LanguageContext";

const META = {
    reading: { color: "hsl(206,70%,52%)" },
    understanding: { color: "hsl(174,72%,46%)" },
    retention: { color: "hsl(38,92%,62%)" },
    mastery: { color: "hsl(152,52%,46%)" },
};

const Ring = ({ value = 0, color, size = 92, stroke = 8, label }) => {
    const r = (size - stroke) / 2;
    const c = 2 * Math.PI * r;
    const pct = Math.max(0, Math.min(100, value));
    const offset = c - (pct / 100) * c;
    return (
        <div className="flex min-w-0 flex-col items-center gap-2">
            <div className="relative" style={{ width: size, height: size }}>
                <svg width={size} height={size} className="-rotate-90">
                    <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="hsl(var(--surface-3))" strokeWidth={stroke} />
                    <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={stroke}
                        strokeDasharray={c} strokeDashoffset={offset} strokeLinecap="round"
                        style={{ transition: "stroke-dashoffset 0.7s cubic-bezier(0.22,1,0.36,1)" }} />
                </svg>
                <div className="absolute inset-0 flex items-center justify-center">
                    <span className="font-sans-display text-lg font-semibold text-t1">{Math.round(pct)}</span>
                </div>
            </div>
            <span className="mono-label w-full truncate text-center text-t4">{label}</span>
        </div>
    );
};

export const ScoreRings = ({ scores = {}, size = 92, className = "" }) => {
    const { t } = useTranslation();
    return (
        <div className={`grid grid-cols-4 gap-2 sm:gap-3 ${className}`} data-testid="score-rings">
            {Object.keys(META).map((k) => (
                <Ring key={k} value={scores[k] || 0} color={META[k].color} size={size} label={t(`scores.${k}`)} />
            ))}
        </div>
    );
};
